// Main entry — the ProgramDetail View. It holds local UI state for the
// draft builder (a stateful View / Container hybrid) but owns no fetch of
// its own; data comes in as props from the Programs page. Sim wrappers
// live under ./sim and are never imported here.
export { ProgramDetail } from "./ProgramDetail";
